import { useState } from "react";
import styles from "./FeaturesGrid.module.scss";
import classNames from "classnames";
import { IoIosArrowUp } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";
import Image from "next/image";

export const FeaturesGrid: React.FC = () => {
  const [open, setOpen] = useState(false);

  const toggleOpen = () => setOpen(!open);

  return (
    <div
      className={classNames(styles.root, open ? styles.open : styles.closed)}
    >
      <GridItem
        image={{
          src: "/assets/images/pages/hearoae/features/features-1.png",
          width: 720,
          height: 407,
        }}
      >
        <h3>SMART DEVICE COMPATIBILITY</h3>
        <div>
          Unlock convenience with our intuitive smartphone-and tablet-based OAE
          device with Bluetooth<sup>®</sup> functionality.
        </div>
      </GridItem>
      <GridItem
        image={{
          src: "/assets/images/pages/hearoae/features/features-2.png",
          width: 720,
          height: 401,
        }}
      >
        <h3>MULTI-FUNCTIONALITY</h3>
        <div>
          Perform OAE, pure tone and digits-in-noise tests with the same hearX®
          smart device.
        </div>
      </GridItem>
      <GridItem
        image={{
          src: "/assets/images/pages/hearoae/features/features-3.png",
          width: 721,
          height: 406,
        }}
      >
        <h3>CLOUD-BASED DATA MANAGEMENT</h3>
        <div>
          Simplify your workflow with real-time, secure cloud-based referral and
          data management, monitoring and reporting,{" "}
          <b>included free of charge during your first year</b>.
        </div>
      </GridItem>
      <GridItem
        image={{
          src: "/assets/images/pages/hearoae/features/features-4.png",
          width: 720,
          height: 400,
        }}
      >
        <h3>EASE OF USE</h3>
        <div>
          Conduct patient-focused testing with our intuitive app design, easy
          navigation, and clearly-presented test results.
        </div>
      </GridItem>
      <GridItem
        image={{
          src: "/assets/images/pages/hearoae/features/features-5.png",
          width: 720,
          height: 403,
        }}
      >
        <h3>EFFICIENCY AND ACCURACY</h3>
        <div>
          Rapid and non-invasive screening method to determine cochlear function
          which can quickly provide objective measurements, allowing for
          efficient screening of large groups, such as newborns or school
          children.
        </div>
      </GridItem>
      <GridItem
        image={{
          src: "/assets/images/pages/hearoae/features/features-6.png",
          width: 720,
          height: 405,
        }}
      >
        <h3>COMPLIANCE AND SECURITY</h3>
        <div>
          hearX® is HIPAA and SOC 2® compliant, which validates our commitment
          to critical security standards to secure and protect customer data.
        </div>
      </GridItem>
      <button onClick={toggleOpen} className={styles.expandButton}>
        View
        {open ? " Less" : " More"}
        {open ? <IoIosArrowUp /> : <IoIosArrowDown />}
      </button>
    </div>
  );
};

const GridItem: React.FC<{
  image: {
    src: string;
    width: number;
    height: number;
    alt?: string;
  };
}> = ({ image, children }) => {
  return (
    <div className={styles.GridItem}>
      <div>
        <img className={styles.image} {...image} />
      </div>
      <div className={styles.text}>
        <div>{children}</div>
      </div>
    </div>
  );
};
